<div class="db-switch-plan-checkout">
  <div class="db-switch-plan-checkout__header">
    <h1 [innerHTML]="title"></h1>
    <p class="mt5">No overlapping fees or extra charges, just more features for the same price.</p>
    <div class="db-switch-plan-checkout__list mt20">
      <p *ngFor="let row of benefits">
        <i class="db-icon db-icon-ds-checkmark mr8"></i>
        <span [innerHTML]="row"></span>
      </p>
    </div>
  </div>

  <div class="db-switch-plan-checkout__content">
    <div class="db-switch-plan-checkout__payment">
      <div>
        <db-payment-info [subscription]="plan"
                         [demoUser]="demoUser"
                         [currentSubscription]="annualSubscription"
                         (onClose)="onClose.emit(!!$event)"
                         (onLoading)="loading = $event"></db-payment-info>
      </div>
      <div class="db-switch-plan-checkout__prices">
        <div class="db-switch-plan-checkout__payment-price" *ngIf="!!userSubscription?.plan?.proratedCredit">
          <div>
            <h1>Original price</h1>
            <b class="light">${{userSubscription?.plan?.planPrice * 12}}</b>
          </div>
          <p class="mt4">Due to your previous purchase, you will receive a ${{userSubscription?.plan?.proratedCredit}} discount off your first payment.</p>
        </div>

        <div class="db-switch-plan-checkout__payment-price mt15">
          <div>
            <h1>{{ 'text_payNow' | dbText}} <i class="db-icon db-icon-info-lined ml5"
                           [dsTooltip]="'The payment will be billed based on<br/> remaining period of your current<br/> subscription plan'"
                           [hostClass]="'cover-all'"
                           dsTooltipPosition="right"
                           dsTooltipAlign="bottom"></i>
            </h1>
            <b>${{userSubscription?.plan?.planPrice * 12 - userSubscription?.plan?.proratedCredit}}</b>
          </div>
          <p class="mt4">Your next payment of ${{userSubscription?.plan?.planPrice * 12}} will be charged on {{expirationDate | date: 'MMM d, y'}}, followed by annual payments of ${{userSubscription?.plan?.planPrice * 12}}.</p>
        </div>
      </div>
    </div>

    <div class="db-switch-plan-checkout__btn-wrap">
      <div>
        <button class="ds-btn-black ds-btn-l" [ngClass]="{'ds-btn-disabled': loading}"
                (click)="paymentInfo.checkoutHandler(coupon); dontCloseDialog()"
                [disabled]="loading" type="submit">
          <span *ngIf="!loading">Confirm Plan Upgrade</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
      </div>
    </div>
  </div>
</div>
